<template>
  <v-navigation-drawer v-model="$store.state.drawer" id="core-navigation-drawer" style="background-color: white;" right
    app width="200" height="100%">
    <v-list style="background-color: white">
      <v-list-item style="background-color: white; padding: 4%">
        <v-img @click="goToDashboard" width="80%" height="100%" src="../../public/Images/Avatar.png"></v-img>
        <v-list-item-content> </v-list-item-content>
      </v-list-item>
      <v-divider style="margin-top: 12px"></v-divider>
    </v-list>
    <v-list expand nav style="color:black !important">
      <div v-for="(link, i) in items" :key="link.title">
        <v-list-item v-if="link.children == undefined" :key="i" :to="link.to" link>
          <v-list-item-icon>
            <v-icon color="black">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="drawer_item_title" v-text="link.title" />
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-else :key="link.title" active-class="white--text">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon x-large>{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ link.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-for="(sublink, index) in link.children">
            <v-list-item :key="sublink.title" :to="sublink.to" link style="margin-right: 40px">
              <v-list-item-icon style="color:black !important">
                <v-icon style="color:black !important" color="black" large>{{ sublink.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="drawer_item_title" v-text="sublink.title" />
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="index" color="#313763" style="margin-left: 35px; margin-right: 35px"></v-divider>
          </template>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "Drawer",
  data() {
    return {
      items: [
        {
          icon: "mdi-view-dashboard",
          title: "داشبورد",
          to: "/",
        },
        {
          icon: "mdi-devices",
          title: "دستگاه ها",
          to: "/devices",
        },
        {
          icon: "mdi-home-city",
          title: "مدیریت گروه بندی",
          to: "/groups",
        },
        {
          icon: "mdi-plus-box",
          title: "اضافه کردن دستگاه",
          to: "/addDevice",
        },
        {
          icon: "mdi-account",
          title: "حساب کاربری",
          to: "/account",
        },
      ],
    };
  },
  methods: {
    goToDashboard() {
      if (this.$route.name != "Dashboard") this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.v-list-item--active {
  background-color: #ffd1b3 !important;
}

.v-list-item__content {
  color: black;
}

.drawer_item_title {
  color: black !important
}

.mdi-devices ::before {
  color: black !important
}
</style>
